export const ModernFormCss = `
  #hubspotForm {
    background: transparent;

    form.hs-form {
      display: grid;
      grid-row-gap: 18px;

      @media (max-width: 480px) {
        grid-row-gap: 8px;
      }

      input,
      textarea,
      select.hs-input {
        width: 100%;
        height: 52px;
        padding: 0 16px;
        border: 1px solid #e1e4e8;
        border-radius: 12px;
        background: #fff;
        font-size: 15px;
        font-family: inherit;
        color: #191919;
        box-sizing: border-box;
        transition: border-color .2s ease, box-shadow .2s ease;

        &:focus,
        &:focus-visible,
        &:active {
          border-color: #0550e2;
          outline: none;
          box-shadow: 0 0 0 3px rgba(5, 80, 226, 0.12);
        }
      }

      textarea {
        height: auto;
        min-height: 120px;
        padding-top: 14px;
        resize: vertical;
      }

      label {
        display: flex;
        justify-content: flex-start;
        color: #6b7280;
        margin-bottom: 6px;
        font-size: 11.5px;
        font-weight: 700;
        letter-spacing: 0.04em;
        text-transform: uppercase;
        align-items: center;
      }

      .hs-form-field {
        @media (max-width: 480px) {
          margin-top: 14px;
        }
      }

      textarea {
        font-size: 14px;
      }

      select.hs-input {
        padding: 0 40px 0 14px;
        font-size: 13px;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6' fill='none'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%236b7280' stroke-width='1.5' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E");
        background-repeat: no-repeat;
        background-position: right 16px center;
        background-size: 10px 6px;
      }

      label.hs-error-msg {
        color: #f72942;
        margin-top: 3px;
        font-size: 11px;
        font-weight: 400;
        letter-spacing: normal;
        text-transform: none;
        line-height: 1.4;
      }

      .legal-consent-container {
        color: #6b7280;
        text-align: left;
        font-size: 12.5px;
        line-height: 1.6;

        a {
          color: #0550e2;
          text-decoration: underline;
        }

        p {
          @media (max-width: 480px) {
            margin-top: 0;
          }
        }
      }

      .actions {
        display: flex;
        margin-top: 4px;

        input {
          width: 100%;
          height: 52px;
          border: none;
          border-radius: 999px;
          background: linear-gradient(135deg, #335cf4, #0550e2);
          color: #fff;
          font-weight: 700;
          font-size: 15px;
          cursor: pointer;
          box-shadow: 0 8px 20px -6px rgba(5, 80, 226, 0.5);
          transition: transform .2s ease, box-shadow .2s ease;

          &:hover {
            transform: translateY(-1px);
            box-shadow: 0 12px 28px -6px rgba(5, 80, 226, 0.6);
          }
        }
      }
    }

    .hs-form-radio {
      label {
        margin: 0 !important;
        cursor: pointer;
        font-weight: 400;

        input {
          width: auto;
          height: auto;
          margin: 0 10px 0 0;
        }

        input[type="radio"] {
          height: auto;
        }
      }
    }
  }
`;
